import { render, staticRenderFns } from "./TaxreportList.vue?vue&type=template&id=624f51d8&"
import script from "./TaxreportList.vue?vue&type=script&lang=js&"
export * from "./TaxreportList.vue?vue&type=script&lang=js&"
import style0 from "./TaxreportList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports